module.exports = __webpack_public_path__ + "font/5cb7edfceb233100075dc9a1e12e8da3.woff";